document.addEventListener("DOMContentLoaded", function () {
    function initInfiniteSlider() {
        // Najdi oba slidy samostatně
        const topSlide = document.querySelector(".slide-top");
        const bottomSlide = document.querySelector(".slide-bottom");

        console.log("Top slide found:", topSlide);
        console.log("Bottom slide found:", bottomSlide);

        // Funkce pro inicializaci jednoho slideru
        function initSlide(slider, trackSelector) {
            if (!slider) {
                console.error("Slider not found");
                return;
            }

            const track = slider.querySelector(trackSelector);
            console.log("Track found:", track, "for selector:", trackSelector);

            if (!track) {
                console.error("Track not found for selector:", trackSelector);
                return;
            }

            const items = Array.from(track.children);
            console.log("Items found:", items.length);

            if (items.length === 0) return;

            // Získej šířku containeru
            const containerWidth = slider.offsetWidth;
            console.log("Container width:", containerWidth);

            // Spočítej šířku všech itemů + gapy
            const gap = 16; // 1.6rem = 16px
            let totalWidth = 0;
            items.forEach((item) => {
                totalWidth += item.offsetWidth + gap;
            });
            console.log("Total width of items:", totalWidth);

            // Vypočítej kolikrát musíme duplikovat
            const neededCopies = Math.max(3, Math.ceil((containerWidth * 2.5) / totalWidth));
            console.log("Needed copies:", neededCopies);

            // Vyklonuj items tolikrát, kolik je potřeba
            for (let i = 0; i < neededCopies; i++) {
                items.forEach((item) => {
                    const clone = item.cloneNode(true);
                    track.appendChild(clone);
                });
            }

            console.log("Total items after cloning:", track.children.length);
        }

        // Inicializuj oba slidy
        if (topSlide) {
            console.log("Initializing top slide...");
            initSlide(topSlide, ".slide-top__items");
        }

        if (bottomSlide) {
            console.log("Initializing bottom slide...");
            // Zkus najít track s oběma možnými selektory
            const bottomTrackExists = bottomSlide.querySelector(".slide-bottom__items");
            const bottomTrackAlt = bottomSlide.querySelector(".slide-top__items");

            if (bottomTrackExists) {
                initSlide(bottomSlide, ".slide-bottom__items");
            } else if (bottomTrackAlt) {
                console.warn("Using .slide-top__items for bottom slide as fallback");
                initSlide(bottomSlide, ".slide-top__items");
            } else {
                console.error("No track found in bottom slide!");
            }
        }
    }

    // Inicializuj slider
    initInfiniteSlider();

    // Reinicializuj při resize (debounced)
    let resizeTimer;
    window.addEventListener("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            // Vyčisti a reinicializuj
            const topTrack = document.querySelector(".slide-top__items");
            const bottomTrack = document.querySelector(".slide-bottom__items");

            if (topTrack) {
                const originalItems = Array.from(topTrack.children).slice(0, 3);
                topTrack.innerHTML = "";
                originalItems.forEach((item) => topTrack.appendChild(item));
            }

            if (bottomTrack) {
                const originalItems = Array.from(bottomTrack.children).slice(0, 3);
                bottomTrack.innerHTML = "";
                originalItems.forEach((item) => bottomTrack.appendChild(item));
            }

            initInfiniteSlider();
        }, 250);
    });

    // SwiperJS pro testimonials
    function initTestimonialSwiper() {
        const testimonialSwiper = new Swiper(".testimonial__content", {
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: {
                delay: 10000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".buttons__next",
                prevEl: ".buttons__prev",
            },
            on: {
                slideChange() {
                    // Reset všechny progress bary
                    const allProgressBars = document.querySelectorAll(".testimonial__progress .progress-fill");
                    allProgressBars.forEach((bar) => {
                        bar.style.width = "0%";
                    });

                    // Spusť animaci pro aktivní slide
                    setTimeout(() => {
                        const activeSlide = document.querySelector(".swiper-slide-active");
                        if (activeSlide) {
                            const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                            if (progressBar) {
                                progressBar.style.width = "100%";
                            }
                        }
                    }, 100);
                },
                init() {
                    // Spusť animaci pro první slide
                    setTimeout(() => {
                        const activeSlide = document.querySelector(".swiper-slide-active");
                        if (activeSlide) {
                            const progressBar = activeSlide.querySelector(".testimonial__progress .progress-fill");
                            if (progressBar) {
                                progressBar.style.width = "100%";
                            }
                        }
                    }, 100);
                },
            },
        });
    }

    // Inicializuj testimonial swiper
    if (document.querySelector(".testimonial__content")) {
        initTestimonialSwiper();
    }

    // SwiperJS pro posts slider
    function initPostsSwiper() {
        const postsSwiper = new Swiper(".posts__slider-swiper", {
            slidesPerView: "auto",
            spaceBetween: 16,
            loop: false,
            freeMode: true,
            navigation: {
                nextEl: ".buttons-posts__next",
                prevEl: ".buttons-posts__prev",
            },
        });
    }

    // Inicializuj posts swiper
    if (document.querySelector(".posts__slider-swiper")) {
        initPostsSwiper();
    }

    // FAQs akordeon funkcionalita
    function initFAQs() {
        const faqItems = document.querySelectorAll(".faqs .items__item");

        faqItems.forEach((item) => {
            const header = item.querySelector(".faq-header");
            const description = item.querySelector(".faq-description");
            const icon = item.querySelector("svg");

            if (header && description) {
                // Skryj description na začátku
                description.style.display = "none";

                // Přidej click event
                header.addEventListener("click", function () {
                    const isOpen = description.style.display !== "none";

                    // Zavři všechny ostatní FAQs
                    faqItems.forEach((otherItem) => {
                        const otherDescription = otherItem.querySelector(".faq-description");
                        const otherIcon = otherItem.querySelector("svg");

                        if (otherItem !== item && otherDescription) {
                            $(otherDescription).slideUp(300);
                            if (otherIcon) {
                                otherIcon.style.transform = "rotate(0deg)";
                            }
                        }
                    });

                    // Toggle aktuální FAQ
                    if (isOpen) {
                        $(description).slideUp(300);
                        if (icon) {
                            icon.style.transform = "rotate(0deg)";
                        }
                    } else {
                        $(description).slideDown(300);
                        if (icon) {
                            icon.style.transform = "rotate(180deg)";
                        }
                    }
                });

                // Nastav cursor pointer pro header
                header.style.cursor = "pointer";

                // Přidej transition pro ikonu
                if (icon) {
                    icon.style.transition = "transform 0.3s ease";
                }
            }
        });
    }

    // Inicializuj FAQs
    if (document.querySelector(".faqs")) {
        initFAQs();
    }
});
